import Vue from "vue";
import Vuex from "vuex";
import {
	getUserDetails,
	getLicenseKey,
	userLogOut,
} from "../../utils/apiFunctions";
import {
	clearCookies,
	getRefreshToken,
	getToken,
	setStore,
} from "@/utils/tokenCheck";
const qs = require("qs");

Vue.use(Vuex);

const state = () => ({
	accessToken: "",
	refreshToken: "",
	isLoggedIn: false,
	userDetails: {},
	hasAssessmentLicense: false,
});

const actions = {
	async getUserData(state) {
		return new Promise((resolve) => {
			getLicenseKey()
				.then((licenseDetails) => {
					if (licenseDetails.status === 200) {
						 state.commit("setAssessmentLicense", licenseDetails.data.data.hasAsssessmentLicense);
						return getUserDetails(licenseDetails.data.data.licenseKey);
					} else {
						resolve(false); // Resolve early if status is not 200
					}
				})
				.then((response) => {
					if (response && response.status === 200) {
						state.commit("setUserDetails", response.data.data.Data[0]);
						resolve(true);
					} else {
						resolve(false); // Resolve early if response status is not 200
					}
				})
				.catch(() => {
					resolve(false); // Handle any errors
				});
		});
	},
	LogOut() {
		userLogOut(
			qs.stringify({
				client_id: "vue-test-app",
				refresh_token: getRefreshToken(),
			}),
			{
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
				Authorization: `Bearer ${getToken()}`,
			}
		)
			.then((response) => {
				setStore("", "", false);
				localStorage.clear();
				clearCookies();
				// location.replace("http://localhost:8080/login?from=training");
				location.replace("https://app.hire3x.com/login?from=training");
				return response;
				// alert("User Logged Out");
			})
			.catch((error) => {
				setStore("", "", false);
				localStorage.clear();
				clearCookies();
				// location.replace("http://localhost:8080/login?from=training");
				location.replace("https://app.hire3x.com/login?from=training");
				console.log(error);
			});
	},
};

const getters = {
	getAccessToken: (state) => state.accessToken,
	getRefreshToken: (state) => state.refreshToken,
	getLoginStatus: (state) => state.isLoggedIn,
	getUserDetails: (state) => state.userDetails,
	hasAssessmentLicense: (state) => state.hasAssessmentLicense,
};

const mutations = {
	setAccessToken(state, token) {
		state.accessToken = token;
	},

	setRefreshToken(state, token) {
		state.refreshToken = token;
	},

	setLoginStatus(state, status) {
		state.isLoggedIn = status;
	},

	setUserDetails(state, details) {
		state.userDetails = details;
	},
	 setAssessmentLicense(state, status) {
        state.hasAssessmentLicense = status;
    },
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
